export default __webpack_public_path__ + "static/media/i_wdt_c_2.389a4d8b.mp3";